import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetAdvertiseList = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/admin/advertise-timer/list/active`)
    }, [])

    return [fetchResult]
}

export default useGetAdvertiseList